import Vue from 'vue'
import App from './app.vue'
import VueBus from 'vue-bus'
import VueI18n from 'vue-i18n'
import store from 'Views/store/store'
import 'Views/css/reset.css'
import 'Views/css/app.css'
import 'Views/css/home/home.css'

Vue.use(VueI18n)

const i18n = new VueI18n({ 
 locale: 'zh',  
 messages: { 
  'zh': require('static/js/zh'), 
  'zh-f': require('static/js/zh-f'), 
  'en': require('static/js/en') 
 } 
})

Vue.use(VueBus);
new Vue({
  el:"#app",
  store,
  i18n,
  template:'<App/>',
  components:{App}
})


// WEBPACK FOOTER //
// ./src/views/pages/home/index.js